import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import { useAppointmentv2 } from 'lib/hooks/queries/appointment/useAppointmentv2';

import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Modal from 'components/shared/Modal/Modal';

import AppointmentFormik from './AppointmentFormik';
import Footer from './components/Footer';
import useAppointmentRescheduled from './hooks/useAppointmentRescheduled';
import { checkUnsavedChanges } from './lib/checkUnsavedChanges';

const Appointment = ({ isOpen, handleClose, appointment: propsAppointment }) => {
  const [, setFormValues] = useState(null);
  const [isUnsaved, setIsUnsaved] = useState(false);
  const [formikValues, setFormikValues] = useState({});
  const [FooterAction, setFooterAction] = useState(<></>);
  const [appointmentId, setAppointmentId] = useState(propsAppointment.id);

  useAppointmentRescheduled({ propsAppointment, handleClose });

  const { data: appointmentData, isLoading } = useAppointmentv2({
    params: {
      id: appointmentId,
      withal: {
        medicalHistory: true,
        payments: true,
        patient: true,
        practitioner: true,
        allergies: true,
        practitionerPractice: true,
        tag: true,
        resources: true
      }
    },
    appointment: appointmentId === propsAppointment.id ? propsAppointment : {}
  });
  const appointment = appointmentData?.appointment;

  useEffect(() => {
    if (appointment) {
      setFormValues(appointment);
    }
  }, [appointment]);

  useEffect(() => {
    if (!isLoading && appointment === -1) {
      handleClose();
    }
  }, [isLoading, appointment]);

  const handleUnsaved = (values, initialValues) => {
    const { isUnsaved } = checkUnsavedChanges(values, initialValues);
    setIsUnsaved(isUnsaved);
    if (!isUnsaved) handleClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      handleClose={() => handleUnsaved(formikValues, appointment)}
      isLarge
      slideFromRight
      disableHeader
      className="flex flex-col bg-white"
      headerClassName="sm:items-start"
      bodyClassName="p-0 overflow-hidden flex flex-col h-full"
      footerClassName="mt-auto h-max z-10"
      footer={
        !isLoading && (
          <Footer
            handleClose={handleClose}
            appointment={formikValues}
            FooterAction={FooterAction}
          />
        )
      }>
      {isLoading || !appointment || appointment === -1 ? (
        <Skeleton count={10} height={100} />
      ) : (
        <AppointmentFormik
          {...{
            handleClose,
            appointment,
            isLoading,
            isUnsaved,
            setIsUnsaved,
            setFormikValues,
            setFooterAction,
            setAppointmentId
          }}
        />
      )}
    </Modal>
  );
};
export default withErrorBoundary(Appointment);
